import { translate } from '@jsverse/transloco';
export enum StatusReportPhaseStatus {
    NOT_COMPLETED = 'NOT_COMPLETED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
}

export class StatusReportPhaseStatusHelper {
    static getStatusReportPhaseStatusString(statusReportPhaseStatus: StatusReportPhaseStatus): string {
        switch (statusReportPhaseStatus) {
            case StatusReportPhaseStatus.NOT_COMPLETED:
                return translate('STATUS_REPORT_PHASE_STATUS.NOT_COMPLETED');
            case StatusReportPhaseStatus.IN_PROGRESS:
                return translate('STATUS_REPORT_PHASE_STATUS.IN_PROGRESS');
            case StatusReportPhaseStatus.COMPLETED:
                return translate('STATUS_REPORT_PHASE_STATUS.COMPLETED');
            default:
                return statusReportPhaseStatus;
        }
    }

    static getStatusReportPhaseStatusIcon(statusReportPhaseStatus: StatusReportPhaseStatus): string {
        switch (statusReportPhaseStatus) {
            case StatusReportPhaseStatus.NOT_COMPLETED:
                return 'cancel';
            case StatusReportPhaseStatus.IN_PROGRESS:
                return 'remove_circle_outline';
            case StatusReportPhaseStatus.COMPLETED:
                return 'check_circle';
            default:
                return '';
        }
    }

    static getStatusReportPhaseStatusIconColor(statusReportPhaseStatus: StatusReportPhaseStatus): string {
        switch (statusReportPhaseStatus) {
            case StatusReportPhaseStatus.NOT_COMPLETED:
                return 'var(--error-color)';
            case StatusReportPhaseStatus.IN_PROGRESS:
                return 'var(--warning-text-color)';
            case StatusReportPhaseStatus.COMPLETED:
                return 'var(--success-color)';
            default:
                return '';
        }
    }

    static getStatusReportPhaseStatusBadgeIconColor(statusReportPhaseStatus: StatusReportPhaseStatus): string {
        switch (statusReportPhaseStatus) {
            case StatusReportPhaseStatus.NOT_COMPLETED:
                return 'error';
            case StatusReportPhaseStatus.IN_PROGRESS:
                return 'info';
            case StatusReportPhaseStatus.COMPLETED:
            default:
                return 'success';
        }
    }
}
